/**
 * @file AdUnitBlogSidebarSlot.tsx
 *
 * @fileoverview Renders a medium rectangle ad (or similar) in the blog detail
 * page sidebar.
 */

export default function AdUnitBlogSidebarSlot() {
  return null;
}

export { AdUnitBlogSidebarSlot };
